import { Component, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, } from '@angular/material/dialog';

import { CargasMasivasService } from 'src/app/services/cargas-masivas/cargas-masivas.service';
import { isNullOrUndefined } from 'util';

import { AlertDialogComponent } from '../alert-dialog/alert-dialog.component';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';

export interface DialogData
{
    tipoCarga: any
    recarga: boolean
}

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';

@Component({
    selector: 'dialog-overview-example-dialog',
    templateUrl: '../../pages/cargas-masivas/crear-cargas-masivas.component.html',
    styleUrls: ['../../pages/cargas-masivas/cargas-masivas.component.css']
})
export class DialogCreaCargaMasiva
{
    cargaMasiva: any = { tipoCarga:null, archivo: File = null, }

    constructor( public dialogRef: MatDialogRef<DialogCreaCargaMasiva>, private dialog: MatDialog,
                 @Inject(MAT_DIALOG_DATA) public data: DialogData,
                 private cargasMasivasService: CargasMasivasService)
    {
        this.data.recarga = false
    }

    ngOnInit(): void { this.loadData() }

    loadData()
    {
        let vm = this

        this.data.tipoCarga = ['AFILIADO', 'CARGA', 'REEMBOLSO']
    }

    csvInputChange(fileInputEvent: any) { 
        this.cargaMasiva.archivo = fileInputEvent.target.files[0] 
    }
  
    

    descargarPlanilla()
    {
        if(this.cargaMasiva.tipoCarga == 'REEMBOLSO')
        {
            let str = '"ree_rut_prestador";"ree_dv_prestador";"ree_tipo_documento";"ree_num_documento";'
                str += '"ree_monto_copago";"ree_monto_reembolso";"ree_fecha_documento";"rut_beneficiario";"dv_beneficiario";"tipo";"reembolso_categoria";"reembolso_sub_categoria";"prevision";"numero_boleta"\r\n';

            let a: any = document.createElement('a')
            a.setAttribute('style', 'display:none;')
            document.body.appendChild(a)

            const blob = new Blob([ str ], { type: 'text/csv' })
            const url = window.URL.createObjectURL(blob)

            a.href = url

            a.download = 'FormatoReembolso.csv'

            a.click()
        }
        else if(this.cargaMasiva.tipoCarga == 'AFILIADO')
        {
            let str = '"USU_NOMBRES";"USU_APELLIDO_PAT";"USU_APELLIDO_MAT";"USU_RUT";"USU_DV";"USU_MAIL";"USU_FECHA_AFILIADO";'
                str += '"USU_TIPO_AFILIADO";"USU_ESTADO";"USU_FONO_FIJO";"USU_FONO_MOVIL";"USU_FECHA_NAC";'
                str += '"USU_SEXO";"ESTADO_CIVIL";'
                str += '"DIRECCION_AFILIADO";"DESC_ADICIONAL_DIR_AFILIADO";"NUMERO_DIR_AFILIADO";'
                str += '"REGION_AFILIADO";"COMUNA_AFILIADO";"TIPO_UNIDAD";"UNIDAD";'
                str += '"CAL_JURIDICA";"ESTAMENTO";"ROL";'
                str += '"DIRECCION_LABORAL";"DESC_ADICIONAL_DIR_LABORAL";"NUMERO_DIR_LABORAL";'
                str += '"REGION_DIR_LABORAL";"COMUNA_DIR_LABORAL";"EMBARAZO";"TIPO_PREVISION"\r\n'

            let a: any = document.createElement('a')
            a.setAttribute('style', 'display:none;')
            document.body.appendChild(a)

            const blob = new Blob([ str ], { type: 'text/csv' })
            const url = window.URL.createObjectURL(blob)

            a.href = url

            a.download = 'FormatoUsuario.csv'

            a.click()

            /*let data1: any =
            [
                {NOMBRES:''}, {APELLIDO_PATERNO:''}, {APELLIDO_MATERNO:''}, {RUT:''}, {DV:''}, {MAIL:''},
                {FECHA_AFILIADO:''}, {TIPO_AFILIADO:''}, {ESTADO:''}, {FONO_FIJO: ''}, {FONO_MOVIL:''},
                {FECHA_NACIMIENTO:''}, {'SEXO(HOMBRE, MUJER)':''}, {'ESTADO_CIVIL(CASADO(A),SOLTERO(A),VIUDO(A),DIVORCIADO(A)':''}
            ]*/

            //let data2: any = [{eid:''},{ename:''},{esal:''}]

            //this.exportAsExcelFile(data1, data2, 'FormatoUsuario')
        }
        else if(this.cargaMasiva.tipoCarga == 'CARGA')
        {
            let str = '"CARGA_NOMBRE";"CARGA_APELLIDO";"CARGA_RUT";"CARGA_DV";"CARGA_FECHA_NACIMIENTO";"CARGA_FECHA_DEFUNCION";"CARGA_PARENTESCO";'
                str += '"CARGA_FECHA_EXPIRACION";"CARGA_RUT_USUARIO";"CARGA_DV_USUARIO";"CARGA_SEXO";"CARGA_TIPO_CARGA";"CARGA_DISCAPACITADO"\r\n';

            let a: any = document.createElement('a')
            a.setAttribute('style', 'display:none;')
            document.body.appendChild(a)

            const blob = new Blob([ str ], { type: 'text/csv' })
            const url = window.URL.createObjectURL(blob)

            a.href = url

            a.download = 'FormatoCarga.csv'

            a.click()
        }
    }

    exportAsExcelFile(json1: any[], json2: any[], excelFileName: string)
    {
        const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json1)
        const worksheet2: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json2)

        /*const workbook: XLSX.WorkBook =
        {
            Sheets: { 'Usuario': worksheet, 'Direccion Personal': worksheet2 },
            SheetNames: ['Usuario', 'Direccion Personal']
        }  */

        const workbook: XLSX.WorkBook = { Sheets: { 'Usuario': worksheet }, SheetNames: ['Usuario'] }

        const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' })

        this.saveAsExcelFile(excelBuffer, excelFileName)
    }

    saveAsExcelFile(buffer: any, fileName: string): void
    {
        const data: Blob = new Blob([buffer], {type: EXCEL_TYPE});
        FileSaver.saveAs(data, fileName + '_export_' + new  Date().getTime() + EXCEL_EXTENSION);
    }

    crearCargaMasiva()
    {
        let vm = this

        if(isNullOrUndefined(this.cargaMasiva.archivo) ||
        this.cargaMasiva.archivo?.type != ('application/vnd.ms-excel' || 'text/csv'))
        {
            this.openAlertDialog('Debe seleccionar un archivo CSV', 'btn-danger')
            return
        }

        this.cargasMasivasService.creaCargaMasiva(this.cargaMasiva).then
        (
            () =>
            {
                vm.openAlertDialog('La carga se proceso correctamente.', 'btn-success')

                vm.data.recarga = true
                vm.dialogRef.close()
            }
        )
        .catch(error =>
        {
            console.log(error)

            vm.openAlertDialog('Ha ocurrido un error al procesar la carga', 'btn-danger')
            vm.dialogRef.close()
        })
    }

    onCancelarClick(): void { this.dialogRef.close() }

    openAlertDialog(mensaje: string, clase: string)
    {
        this.dialog.open(AlertDialogComponent, {
            data: { message: mensaje, clase: clase, buttonText: { cancel: 'Listo!' }, }
        })
    }
}
